import axios from "axios";
import {estimateServicesPath,} from "../../../Constants";

const estimateRestUrl = estimateServicesPath + '/model-estimates'

export default class ModelEstimateService {

    static async getAllByModelId(id) {
        return axios.get(estimateRestUrl + '/model/' + id);
    }

    static async create(basicModelId) {
        return axios.post(estimateRestUrl + '?basicModelId=' + basicModelId);
    }

    static async unableCurrent(id, basicModelId) {
        return axios.patch(estimateRestUrl + '/' + id + '/unable-current' + '?basicModelId=' + basicModelId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(estimateRestUrl + '/' + id);
    }
}